"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
const Log_1 = __importDefault(require("@common/Log"));
class Network {
    static httpPostFile(url, opts, formData) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("Network::httpPostFile( " + url + " ) - start");
            const headers = {};
            if (opts !== null && typeof opts === "object" && typeof opts.headers === "object" && opts.headers !== null) {
                for (const name of Object.keys(opts.headers)) {
                    if (name.toLowerCase() === "content-type") {
                        Log_1.default.trace("Network::httpPostFile( " + url + " ) - dropping caller Content-Type: " + opts.headers[name]);
                        continue;
                    }
                    headers[name] = opts.headers[name];
                }
            }
            const postOptions = Object.assign({ method: "post", cors: "enabled", body: formData }, opts, { headers: headers });
            try {
                const data = yield fetch(url, postOptions);
                Log_1.default.trace("Network::httpPostFile( " + url + " ) - success");
                return data;
            }
            catch (err) {
                Log_1.default.trace("Network::httpPostFile( " + url + " ) - ERROR " + err);
                throw err;
            }
        });
    }
}
exports.Network = Network;
